var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoAsegurameBlanco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 226.988,
    height: 42.963,
    viewBox: "0 0 226.988 42.963",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17320",
    "data-name": "Grupo 17320",
    transform: "translate(-70.477 -227.718)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15046",
    "data-name": "Grupo 15046",
    transform: "translate(70.477 227.718)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_36398",
    "data-name": "Trazado 36398",
    d: "M84.588,239.912l7.1,16.565L84.03,274.319a3.394,3.394,0,0,1-3.108,2.052l-7.038.018a3.393,3.393,0,0,1-3.126-4.734l13.757-31.922Z",
    transform: "translate(-70.477 -233.43)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_36399",
    "data-name": "Trazado 36399",
    d: "M113.821,230.3l-.227-.528a3.393,3.393,0,0,0-3.117-2.052H103.5a3.393,3.393,0,0,0-3.117,2.052l-.228.529a3.355,3.355,0,0,0,.177,2.153l6.657,15.515,6.658-15.515A3.352,3.352,0,0,0,113.821,230.3Z",
    transform: "translate(-84.537 -227.718)",
    fill: "#a01779"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15047",
    "data-name": "Grupo 15047",
    transform: "translate(124.009 237.775)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_36400",
    "data-name": "Trazado 36400",
    d: "M186.357,263.348h-8.166l-1.351,3.867h-4.317l7.372-20.326h4.787l7.372,20.326h-4.347ZM182.274,251.6l-2.966,8.491h5.932Z",
    transform: "translate(-172.523 -246.889)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_36401",
    "data-name": "Trazado 36401",
    d: "M220.452,271.061c-4.082,0-6.931-2.355-7.108-5.351h4.141a2.7,2.7,0,0,0,2.937,2.152c1.616,0,2.5-.727,2.5-1.658,0-2.878-9.193-1.047-9.193-6.95,0-2.675,2.408-4.827,6.432-4.827,3.935,0,6.314,2.123,6.549,5.321h-3.935c-.117-1.251-1.116-2.094-2.731-2.094-1.528,0-2.321.611-2.321,1.542,0,2.937,9.017,1.105,9.135,7.008C226.855,268.967,224.417,271.061,220.452,271.061Z",
    transform: "translate(-191.93 -250.473)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_36402",
    "data-name": "Trazado 36402",
    d: "M251.692,271.061c-4.73,0-8.166-3.257-8.166-8.316,0-5.09,3.348-8.317,8.166-8.317a7.6,7.6,0,0,1,8.018,7.968,9.367,9.367,0,0,1-.117,1.57H247.7a3.79,3.79,0,0,0,3.906,3.722,3.356,3.356,0,0,0,3.26-1.948H259.3A7.555,7.555,0,0,1,251.692,271.061Zm-3.965-9.829h7.724a3.6,3.6,0,0,0-3.877-3.461A3.766,3.766,0,0,0,247.726,261.232Z",
    transform: "translate(-206.279 -250.473)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_36403",
    "data-name": "Trazado 36403",
    d: "M285.507,254.428a6.387,6.387,0,0,1,5.375,2.559v-2.3h4.142v16.226c0,4.362-2.7,7.822-8.048,7.822-4.582,0-7.783-2.268-8.2-5.961h4.083c.411,1.454,1.938,2.414,3.995,2.414,2.261,0,4.024-1.279,4.024-4.275v-2.5a6.437,6.437,0,0,1-5.375,2.646c-4.142,0-7.431-3.344-7.431-8.374S281.365,254.428,285.507,254.428ZM286.564,258a4.316,4.316,0,0,0-4.288,4.682c0,3.053,2.086,4.8,4.288,4.8,2.261,0,4.317-1.687,4.317-4.74S288.826,258,286.564,258Z",
    transform: "translate(-222.705 -250.473)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_36404",
    "data-name": "Trazado 36404",
    d: "M333.285,271.036h-4.141V269a6.026,6.026,0,0,1-4.847,2.239c-3.789,0-6.52-2.443-6.52-6.863v-9.451h4.112V263.8c0,2.588,1.439,3.983,3.613,3.983,2.232,0,3.642-1.4,3.642-3.983v-8.869h4.141Z",
    transform: "translate(-241.579 -250.71)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_36405",
    "data-name": "Trazado 36405",
    d: "M359.183,270.826h-4.112V254.716h4.112v2.5a5.656,5.656,0,0,1,4.994-2.733v4.274h-1.087c-2.438,0-3.907.931-3.907,4.042Z",
    transform: "translate(-259.31 -250.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_36406",
    "data-name": "Trazado 36406",
    d: "M383.109,254.428a6.458,6.458,0,0,1,5.375,2.559v-2.3h4.142V270.8h-4.142v-2.355a6.439,6.439,0,0,1-5.4,2.617c-4.112,0-7.4-3.344-7.4-8.374S378.968,254.428,383.109,254.428ZM384.167,258a4.316,4.316,0,0,0-4.288,4.682c0,3.053,2.086,4.8,4.288,4.8,2.262,0,4.317-1.687,4.317-4.74S386.428,258,384.167,258Z",
    transform: "translate(-269.107 -250.473)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_36407",
    "data-name": "Trazado 36407",
    d: "M438.423,261.928c0-2.559-1.439-3.9-3.613-3.9-2.2,0-3.642,1.338-3.642,3.9v8.9h-4.112v-8.9c0-2.559-1.439-3.9-3.612-3.9-2.232,0-3.672,1.338-3.672,3.9v8.9H415.66V254.716h4.112v1.948a5.949,5.949,0,0,1,4.788-2.181,6.243,6.243,0,0,1,5.727,3.082,6.455,6.455,0,0,1,5.58-3.082c3.907,0,6.667,2.442,6.667,6.891v9.45h-4.112Z",
    transform: "translate(-288.115 -250.5)",
    fill: "#0099b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_36408",
    "data-name": "Trazado 36408",
    d: "M480.494,271.061c-4.729,0-8.165-3.257-8.165-8.316,0-5.09,3.348-8.317,8.165-8.317a7.6,7.6,0,0,1,8.018,7.968,9.429,9.429,0,0,1-.117,1.57H476.5a3.79,3.79,0,0,0,3.906,3.722,3.356,3.356,0,0,0,3.26-1.948H488.1A7.555,7.555,0,0,1,480.494,271.061Zm-3.965-9.829h7.725a3.6,3.6,0,0,0-3.877-3.461A3.766,3.766,0,0,0,476.529,261.232Z",
    transform: "translate(-315.056 -250.473)",
    fill: "#0099b7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_36409",
    "data-name": "Trazado 36409",
    d: "M135.442,268.253l-15.351-35.685a3.487,3.487,0,0,1-.18,2.2l-6.639,15.47,8.9,20.68a3.394,3.394,0,0,0,3.108,2.052l7.038.018A3.394,3.394,0,0,0,135.442,268.253Z",
    transform: "translate(-20.345 -2.306)",
    fill: "#0099b7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAsegurameBlanco);
export default __webpack_public_path__ + "static/media/Logo-Asegurame-Blanco.81a6238485e43f21f2ef2ff6974eb22f.svg";
export { ForwardRef as ReactComponent };